import { render, staticRenderFns } from "./assistantChatViewer.vue?vue&type=template&id=49cc90e1&scoped=true"
import script from "./assistantChatViewer.vue?vue&type=script&lang=js"
export * from "./assistantChatViewer.vue?vue&type=script&lang=js"
import style0 from "./assistantChatViewer.vue?vue&type=style&index=0&id=49cc90e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc90e1",
  null
  
)

export default component.exports